import { socialLinks } from '../../socialLinks';
import './Footer.scss';

export const Footer = () => {
  return (
    <footer>
      <footer className='p-4 text-center'>
        <div className='container p4'>
          <p>Copyright © {new Date().getFullYear()} - All rights reserved</p>
          <ul className='list-inline mb-0'>
            {socialLinks.map(link => (
              <li className='list-inline-item px-1' key={link.title}>
                <a
                  href={link.href}
                  target='__blank'
                  title={link.title}
                  dangerouslySetInnerHTML={{ __html: link.icon }}
                />
              </li>
            ))}
          </ul>
        </div>
      </footer>
    </footer>
  );
};
